"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWorldwideGeolocationStencil = exports.worldwideGeolocationStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.worldwideGeolocationStencilDefinition = {
    view: {
        label: 'Worldwide Geolocation',
        group: 'Misc.',
        titleItems: ['title'],
        contentAreas: [
            {
                name: 'main',
                items: ['title'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
        ],
    },
    content: {
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
    },
    roles: ['taxonomy-manager'],
    localizations: [],
    spaces: [
        'batalla',
        'brand-building-events',
        'global',
        'illume',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-advancedtechnologies',
        'redbull-racing',
        'redbull-powertrains',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
    ],
    name: 'worldwide-geolocation',
};
const isWorldwideGeolocationStencil = (stencil) => {
    return stencil.name === exports.worldwideGeolocationStencilDefinition.name;
};
exports.isWorldwideGeolocationStencil = isWorldwideGeolocationStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid29ybGR3aWRlLWdlb2xvY2F0aW9uLnN0ZW5jaWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3RlbmNpbHMvd29ybGR3aWRlLWdlb2xvY2F0aW9uLnN0ZW5jaWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsOENBSXNCO0FBRVQsUUFBQSxxQ0FBcUMsR0FBRztJQUNuRCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsdUJBQXVCO1FBQzlCLEtBQUssRUFBRSxPQUFPO1FBQ2QsVUFBVSxFQUFFLENBQUMsT0FBTyxDQUFDO1FBQ3JCLFlBQVksRUFBRTtZQUNaO2dCQUNFLElBQUksRUFBRSxNQUFNO2dCQUNaLEtBQUssRUFBRSxDQUFDLE9BQU8sQ0FBQzthQUNqQjtZQUNEO2dCQUNFLElBQUksRUFBRSxNQUFNO2dCQUNaLFFBQVEsRUFBRTtvQkFDUjt3QkFDRSxJQUFJLEVBQUUsVUFBVTt3QkFDaEIsS0FBSyxFQUFFLENBQUMsWUFBWSxDQUFDO3FCQUN0QjtvQkFDRDt3QkFDRSxJQUFJLEVBQUUsbUJBQW1CO3dCQUN6QixLQUFLLEVBQUUsQ0FBQyxzQkFBc0IsQ0FBQztxQkFDaEM7aUJBQ0Y7YUFDRjtTQUNGO0tBQ0Y7SUFDRCxPQUFPLEVBQUU7UUFDUCxDQUFDLGtEQUFxQyxDQUFDLElBQUksQ0FBQyxFQUFFLGtEQUFxQztRQUNuRixDQUFDLHlDQUE0QixDQUFDLElBQUksQ0FBQyxFQUFFLHlDQUE0QjtRQUNqRSxDQUFDLG9DQUF1QixDQUFDLElBQUksQ0FBQyxFQUFFLG9DQUF1QjtLQUN4RDtJQUNELEtBQUssRUFBRSxDQUFDLGtCQUFrQixDQUFDO0lBQzNCLGFBQWEsRUFBRSxFQUFFO0lBQ2pCLE1BQU0sRUFBRTtRQUNOLFNBQVM7UUFDVCx1QkFBdUI7UUFDdkIsUUFBUTtRQUNSLFFBQVE7UUFDUixVQUFVO1FBQ1YsNEJBQTRCO1FBQzVCLGFBQWE7UUFDYixjQUFjO1FBQ2QsZUFBZTtRQUNmLFlBQVk7UUFDWiw4QkFBOEI7UUFDOUIsZ0JBQWdCO1FBQ2hCLHFCQUFxQjtRQUNyQixhQUFhO1FBQ2IsYUFBYTtRQUNiLGNBQWM7UUFDZCxZQUFZO0tBQ2I7SUFDRCxJQUFJLEVBQUUsdUJBQXVCO0NBQ0MsQ0FBQTtBQUl6QixNQUFNLDZCQUE2QixHQUFHLENBQUMsT0FBb0IsRUFBMEMsRUFBRTtJQUM1RyxPQUFPLE9BQU8sQ0FBQyxJQUFJLEtBQUssNkNBQXFDLENBQUMsSUFBSSxDQUFBO0FBQ3BFLENBQUMsQ0FBQTtBQUZZLFFBQUEsNkJBQTZCLGlDQUV6QyJ9